



















































import { Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import Vue from "vue";
import { passwordApi } from "../services/password.api";
import appSnackbarService from "../../../services/appSnackbar.service";
import { PASSWORD_POLICY_REGEX } from "../../../helpers/passwordPolicy";

@Component({})
export default class ResetPassword extends Vue {
  password1 = "";
  password2 = "";
  userName = "";
  errorMessage = "";
  valid = false;
  loading = false;

  passwordRule = v => {
    if (!PASSWORD_POLICY_REGEX.test(v)) {
      return this.$t("CHANGE_PASSWORD_RULE") as string;
    }
    return true;
  }

  changePassword() {
    (this.$refs.form as any).validate();
    if (this.valid) {
      this.loading = true;
      passwordApi
        .resetPassword(this.userName, this.password2, this.$route.query.token)
        .then(() => {
          this.$router.replace("/login");
          appSnackbarService.success(
            "Sikeres jelszo beallitás! Bejelentkezhet az uj jelszoval!"
          );
        })
        .catch(error => {
          this.errorMessage =
            "Hiba tortent a jelszo beállitásakor. " +
            "Kervenyezzen uj <a href='/passwordReset'>jelszo visszaállitást</a>!";
          this.loading = false;
        });
    }
  }
}
